import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import queryString from 'query-string';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { Card, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { USER_PROFILE_RESOURCES, PAGE_NAMES } from 'constant';

import { UserDetailsContext } from 'context/userDetails';
import { URL, LABEL, IMAGE_SOURCE } from './helper';
import { FORM_FIELD_LABELS } from './selectUser/formConfig';
import { ACL_CRM_RESOURCES } from '../constants';

const useUserProfileHome = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (configResourceName: string) => {
		if (ACL_CRM_RESOURCES.includes(configResourceName)) {
			return hasPermissionV2({
				configPageName: PAGE_NAMES.userProfile,
				configResourceName
			});
		}
		return hasPermissionV2({
			configPageName: PAGE_NAMES.userProfile,
			configResourceName
		});
	};

	return { isEnabled };
};

const UserProfileHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useUserProfileHome();
	const { userSearchDetails } = useContext(UserDetailsContext);
	const queryParams = _get(history, ['location', 'search']);

	const handleChangeUser = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		history.push('/userProfile/selectUser');
	};

	if (_isNil(queryParams) && _isEmpty(queryParams)) {
		if (_isNil(userSearchDetails) || _isEmpty(userSearchDetails)) {
			history.push('/userProfile/selectUser');
		} else if (_isNil(_get(history, ['location', 'search']))) {
			const { selectionType, selectedValue } = userSearchDetails;
			history.push({
				pathname: '/userProfile/home',
				search: `?${queryString.stringify({ [selectionType || '']: selectedValue })}`
			});
		}
	}

	return (
		<div className={css({ display: 'flex', flexDirection: 'column', gap: '70px', marginTop: '70px', marginBottom: '70px' })}>
			<div
				className={css({
					display: 'flex',
					justifyContent: 'center'
				})}>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'space-around',
						backgroundColor: 'white',
						padding: '10px',
						gap: '30px'
					})}>
					<div
						className={css({
							display: 'flex',
							justifyContent: 'space-around',
							gap: '10px'
						})}>
						<div
							className={css({
								fontSize: '16px',
								fontWeight: 'bold',
								padding: '14px 0px'
							})}>{`${_get(
							FORM_FIELD_LABELS,
							_get(userSearchDetails, 'selectionType', EMPTY_STRING),
							EMPTY_STRING
						)}:`}</div>
						<div className={css({ fontSize: '16px', padding: '14px 0px' })}>{userSearchDetails.selectedValue}</div>
					</div>
					<Button onClick={handleChangeUser} kind='primary'>
						Change User
					</Button>
				</div>
			</div>
			<div
				className={css({
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-evenly',
					alignItems: 'center',
					height: '100%',
					flexWrap: 'wrap',
					gap: '25px'
				})}>
				{_map(_keys(USER_PROFILE_RESOURCES), (resourceName: string) => {
					return isEnabled(resourceName) ? (
						<div
							key={resourceName}
							className={css({
								height: '130px',
								width: '30%',
								cursor: 'pointer',
								display: 'flex',
								justifyContent: 'space-around'
							})}
							role='button'
							tabIndex={0}
							onClick={(e) => {
								e.preventDefault();

								history.push({
									pathname: URL[resourceName],
									search: _get(history, ['location', 'search'], '')
								});
							}}>
							<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
						</div>
					) : null;
				})}
			</div>
		</div>
	);
};

export default UserProfileHome;
